import { useState } from 'react';

import { EllipsisIcon, EllipsisVerticalIcon } from 'lucide-react';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { preventClickThrough } from '@/util/util';

export interface Props {
  direction?: 'vertical' | 'horizontal';
  menuItems: {
    name: string;
    variant?: 'default' | 'destructive';
    icon: React.ReactNode;
    onClick: (e) => void;
    keepOpen?: boolean;
    tooltipMessage?: string;
    disabled?: boolean;
  }[];
}

const TileMenu = ({ menuItems, direction = 'vertical' }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild onClick={preventClickThrough}>
        <Button variant="ghost-neutral" size="icon-sm" aria-label="more">
          {direction === 'vertical' ? (
            <EllipsisVerticalIcon size={20} />
          ) : (
            <EllipsisIcon size={20} />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {menuItems.map((option) => {
          const item = (
            <DropdownMenuItem
              key={option.name}
              variant={option.variant}
              disabled={option.disabled}
              onClick={(e) => {
                if (option.keepOpen) {
                  e.preventDefault();
                }
                try {
                  option.onClick(e);
                  preventClickThrough(e);
                } catch (error) {
                  console.error(error);
                }
              }}
            >
              {option.icon}
              <span>{option.name}</span>
            </DropdownMenuItem>
          );

          if (option.tooltipMessage) {
            return (
              <InfoTooltip key={option.name} content={option.tooltipMessage} size="auto">
                {item}
              </InfoTooltip>
            );
          }

          return item;
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TileMenu;
